import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import {
    AppBar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Divider,
    Grid,
    IconButton,
    Stack,
    TextField,
    Toolbar,
    Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import AgGridTable from "../utilities/AgGridTable";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import CustomDatePicker from "../utilities/CustomDatePicker";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";

const EditCreatedProformaInvoice = (props) => {
    const gridRef = useRef();
    const [formOpen, setFormOpen] = useState(props.editPI || props.viewPI || false);
    const [rowData, setRowData] = useState(props.editData.detailData || []);
    const [piData, setPiData] = useState(props.editData);
    const [successMsg, setSuccessMsg] = useState();
    const [editTotal, setEdittotal] = useState(0);
    const [selectedRows, setSelectedRows] = useState([]);
    const [proformaCreated, setProformaCreated] = useState(false);
    const [error, setError] = useState();
    const [paymentCodesOptions, setPaymentCodeOptions] = useState([]);
    const [orderCategoriesOptions, setOrderCategoriesOptions] = useState([
        { label: 'RETAIL', value: 'RETAIL' },
        { label: 'PROJECT', value: 'PROJECT' },
    ]);

    const [gridApi, setGridApi] = useState();

    const renderCurrency = (props) => {
        return <span style={{ display: "flex" }}>
            <p>{props?.value && new Intl.NumberFormat('en-US').format(props?.value)}</p>
        </span>;
    };

    const [columnDefs, setColumnDefs] = useState([
        {
            field: "abNumber",
            headerName: "AB Number",
            minWidth: 100,
        },
        { field: "commissionName", headerName: "Commission", minWidth: 200 },
        { field: "orderCategory", minWidth: 100 },
        { field: "paymentTerm", minWidth: 100 },
        { field: "piValue", headerName: "NME RCBL", minWidth: 100, cellRenderer: renderCurrency },
        { field: "internalContainerNo", headerName: "Intl Cntr No", minWidth: 100 },
        { field: "actualLoadingDate", headerName: "Actual Loading Date", minWidth: 100 },
        { field: "actualLoadingWeek", headerName: "Actual Loading Week", minWidth: 100 },
    ]);
    const PIurl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.ProformaInvoice}`;
    const paymentCodeurl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.paymentTerms}`;

    const handleViewClose = () => {
        setFormOpen(false);
    };

    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    }

    const loadPIData = async () => {
        const editData = await OAuthService.getList(PIurl + `/getProformaInvoice/${props?.editData?.piNumber}`)
        if (editData?.data) {
            setPiData(editData?.data)
            if(editData?.data?.retailOrdersList.length > 0){
                editData?.data?.retailOrdersList.map((data) => {
                    data.piValue = data.grandTotal
                    return data;
                })
            }

            if(editData?.data?.projectOrdersList.length > 0){
                editData?.data?.projectOrdersList.map((data) => {
                    data.piValue = data.grandTotal
                    return data;
                })
            }
            const allrows = [...editData?.data?.retailOrdersList, ...editData?.data?.projectOrdersList]
            setRowData(allrows)
        }
    }

    const getPaymentCode = async () => {
        const types = await OAuthService.getList(paymentCodeurl);
        let paymenTerm = types?.data?._embedded?.paymentTerms.map((type) => {
            return { label: type.code + ' ' + type.paymentCondition, value: type.id, paymentCondition: type.paymentCondition, paymentInstallmentList: type.paymentInstallmentList }
        });
        if (paymenTerm && paymenTerm.length > 0) {
            setPaymentCodeOptions(paymenTerm)
        }
    }

    const getAllIntlContainerData = async () => {
        const list = await OAuthService.getList(PIurl + '/getallreadyforpiorders');

        let data = list.data;
        const filteredList = list?.data.filter((data) => {
            if (piData?.internalContainerNo === data?.internalContainerNo) {
                return true
            }
        })
        setRowData(filteredList)
    }

    useEffect(() => {
        let pitotal = 0;
        rowData.map((val) => {
            if (val?.grandTotal) {
                pitotal = pitotal + Number(val?.grandTotal)
            }
        });
        setEdittotal(new Intl.NumberFormat('en-US').format(pitotal))
    }, [rowData])

    useEffect(() => {

        getPaymentCode();
        if (props?.editData?.piNumber) {
            loadPIData()
        } else {
            if (!props?.editData?.detailData || props?.editData?.detailData.length === 0) {
                getAllIntlContainerData()
            }
        }
    }, []);

    const onGridReady = (params) => {
        setGridApi(params.api);
    };

    useEffect(() => {
        props.handleEditForm(formOpen)
    }, [formOpen])

    const handleSave = async () => {
        try {
            if (piData?.piNumber) {
                const ordersId = selectedRows.map((data) => data.orderId)
                const editModel = {
                    "piNumber": piData.piNumber,
                    "orderType": piData.orderCategory,
                    "paymentTermId": piData.paymentTerm,
                    "orderIds": ordersId
                }

                const list = await OAuthService.addData(PIurl + '/addPaymentTermToPi', editModel)

                if (list?.data) {
                    setSuccessMsg(list?.data || "Proforma Invoice updated Successfully")
                }
            } else {
                const ordersId = rowData[0]?.internalContainerNo
                const list = await OAuthService.addData(PIurl + '/generateproformainvoice', { "containerNumList": [ordersId],  "sendEmail": false,
                "withStamp": false,
                "withSign": false });
                const url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.ProformaInvoices}`;
                const pilist = await OAuthService.getList(url + `/search/findAllByInternalContainerNoIn?containerNums=${piData.internalContainerNo}`)
                const piNumber = pilist?.data?._embedded?.proformaInvoices[0]?.piNumStr

                const selectedordersId = selectedRows.map((data) => data.orderId)
                const editModel = {
                    "piNumber": piNumber,
                    "orderType": piData.orderCategory,
                    "paymentTermId": piData.paymentTerm,
                    "orderIds": selectedordersId
                }

                await OAuthService.addData(PIurl + '/addPaymentTermToPi', editModel)
                setSuccessMsg(list?.data || "Data saved Successfully")
                setProformaCreated(true)
            }
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
        setFormOpen(false)
    }

    const handleOrderTypeChange = (e) => {
        setPiData({ ...piData, orderCategory: e.value })
    }
    const handlePaymentTermChange = (e) => {
        setPiData({ ...piData, paymentTerm: e.value })
    }

    useEffect(() => {
        props.successMsg(successMsg)
    }, [successMsg]);
    useEffect(() => {
        if (props.proformaCreated) {
            props.proformaCreated(proformaCreated)
        }
    }, [proformaCreated]);

    useEffect(() => {
        props.error(error)
    }, [error]);

    return (
        <>

            <Dialog
                open={formOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth={"md"}
            >
                <AppBar position="static">
                    <Toolbar className="flex w-full justify-between">
                        <Typography variant="subtitle1" color="inherit">
                            {props.viewPI ? "View Proforma Invoice" : "Edit Proforma Invoice"}
                        </Typography>
                        <div >

                            <Button onClick={handleViewClose}>
                                <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                            </Button>
                        </div>
                    </Toolbar>
                </AppBar>
                <DialogContent dividers >
                    <Grid container spacing={2}>
                        <Grid item xs={2}>

                            <label className="float-left pr-5 ">PI Number</label>
                            <TextField
                                name="pi_number"
                                value={piData?.piNumber}
                                // onChange={handlechangecompany}
                                inputProps={{
                                    sx: { padding: "10px" },
                                }}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <Stack>
                                <label className="float-left pr-5 ">Name</label>
                                <TextField
                                    name="name"
                                    value={piData?.custName}
                                    // onChange={handlechangecompany}
                                    inputProps={{
                                        sx: { padding: "10px" },
                                    }}
                                    disabled
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={2}>

                            <label className="float-left pr-5 ">Customer</label>
                            <TextField
                                name="customer"
                                value={piData?.custNum}
                                // onChange={handlechangecompany}
                                inputProps={{
                                    sx: { padding: "10px" },
                                }}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Stack className="ml-10">
                                <label className="min-w-fit">Date </label>
                                <div className="grid">
                                    <TextField
                                        className="w-[150px] h-[20px]"
                                        name={'date'}
                                        disabled={true}
                                        value={piData?.piDate}

                                    />
                                </div>
                            </Stack>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>

                        <Grid item xs={4}>

                            <Stack className="mt-8">
                                <label className="min-w-fit">Order Type</label>
                                <Select
                                    name="orderType"
                                    className="min-w-fit"
                                    isDisabled={props.viewPI ? true : false}
                                    value={(piData?.orderCategory && orderCategoriesOptions.length > 0) && orderCategoriesOptions.filter((list) => list.value === piData?.orderCategory)}
                                    onChange={handleOrderTypeChange}
                                    options={orderCategoriesOptions}
                                    styles={customStyles('', '', '0px')}
                                />
                            </Stack>
                        </Grid>

                        <Grid item xs={4}>
                            <Stack className="mt-6">
                                <label className="min-w-fit">Payment Condition</label>
                                <Select
                                    name="paymenTerm"
                                    className="min-w-fit"
                                    isDisabled={props.viewPI ? true : false}
                                    value={(piData?.paymenTerm && paymentCodesOptions.length > 0) && paymentCodesOptions.filter((list) => list.value === piData?.paymenTerm)}
                                    onChange={handlePaymentTermChange}
                                    options={paymentCodesOptions}
                                    styles={customStyles('', '', '0px')}
                                />

                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            {/* <TextField
                                name="payment_condition"
                                disable
                                inputProps={{
                                    sx: { 'padding': '10px' },

                                }}
                                style={{ marginTop: "26px" }}
                            /> */}
                        </Grid>
                    </Grid>
                    <Divider className="mt-10" sx={{ borderBottomWidth: 3 }} />
                    <Grid container>
                        <Grid item xs={12} className="h-[300px] mt-10">
                            <AgGridTable
                                onGridReady={onGridReady}
                                columnDefs={columnDefs}
                                rowData={rowData}
                                gridRef={gridRef}
                                editable={false}
                                onSelectionChanged={onSelectionChanged}
                                floatingFilter={false}
                                rowGroupPanelShow="never"
                            />
                            <div className="flex justify-end items-baseline mt-8 ">
                                <label className="mr-8" >Total</label>
                                <TextField
                                    name="total"
                                    disabled
                                    value={editTotal}
                                    inputProps={{
                                        sx: { 'width': '150px' },
                                    }} />
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={handleSave}
                        disabled={props.viewPI ? true : selectedRows.length > 0 ? false : true}
                    >
                        <FuseSvgIcon>material-solid:save</FuseSvgIcon>
                    </Button>
                </DialogActions>
            </Dialog >

        </>
    );
};
export default EditCreatedProformaInvoice;
